import React, { useState, useEffect, useContext } from 'react';
import { Select, Spin } from 'antd';

import { AuthContext } from '../../containers/App';
import * as COM from '.';

export const DatasetSelectAutoComplete = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataOrig] = useState([]);
  const auth = useContext(AuthContext);


  const onSearch = async (value) => {
    const DEFAULT_AUTOCOMPLETE_FILTER_CASE_SENSITIVE = { title: { '$like': value + "%" } };
    const DEFAULT_AUTOCOMPLETE_FILTER_CASE_INSENSITIVE = { title: { '$ilike': value + "%" } };
    setLoading(true);
    if (value !== "" && value.length > 2) {
      let data = await COM.fetchData({
        connector: props.connector,
        dataset: props.dataset,
        filters: props.filters === undefined
          ? Object.assign(
            {},
            props.caseInsensitive
              ? DEFAULT_AUTOCOMPLETE_FILTER_CASE_INSENSITIVE
              : DEFAULT_AUTOCOMPLETE_FILTER_CASE_SENSITIVE)
          : Object.assign(
            {},
            props.filters,
            props.caseInsensitive
              ? DEFAULT_AUTOCOMPLETE_FILTER_CASE_INSENSITIVE
              : DEFAULT_AUTOCOMPLETE_FILTER_CASE_SENSITIVE)
      }, auth, false);
      setData(data);
    } else {
      setData(dataOrig);
    }
    setLoading(false);
  }

  const init = async () => {
    setLoading(true);
    let data = await COM.fetchData({
      connector: props.connector,
      dataset: props.dataset,
      filters: props.filters === undefined ? Object.assign({}, { value: { '$eq': props.value } }) : Object.assign({}, props.filters, { value: { '$eq': props.value } })
    }, auth, false);
    setData(data);
    setLoading(false);
  }

  useEffect(() => {
    if (props.value) {
      init();
    }
  }, props.invalidateEffect ? props.invalidateEffect : [])

  return (
    <Select
      showSearch
      onSearch={onSearch}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : null}
      mode={props.multiple ? 'multiple' : null}
      {...props}
    >
      {data.map((item, idx) => {
        return (
          <Select.Option
            key={item.value}
            value={item.value}
          >
            {item.title}
          </Select.Option>
        );
      })}
    </Select>
  );
};